import React, { useState } from 'react';

export default function DemoLodgeSite() {
  const [activeFaq, setActiveFaq] = useState(null);

  const toggleFaq = (idx) => {
    setActiveFaq(activeFaq === idx ? null : idx);
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#070b14',
      color: '#f8fafc',
      fontFamily: "'Plus Jakarta Sans', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      overflowX: 'hidden'
    }}>
      {/* 1. SALES DEMO MODE TOP BANNER */}
      <div style={{
        background: 'linear-gradient(90deg, #1e3a8a 0%, #0369a1 50%, #b45309 100%)',
        color: '#ffffff',
        padding: '8px 16px',
        fontSize: '12px',
        fontWeight: '600',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
        position: 'sticky',
        top: 0,
        zIndex: 1000
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{
            background: '#f59e0b',
            color: '#000',
            padding: '2px 8px',
            borderRadius: '999px',
            fontSize: '10px',
            fontWeight: '800',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            Sales Demo
          </span>
          <span>
            Simulated Lodge Website &bull; Demonstrating how TrophyCoin transforms guest catches into viral referrals &amp; direct bookings
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <a
            href="/c/0006ccf49cf46d98"
            target="_blank"
            rel="noreferrer"
            style={{
              color: '#fde68a',
              textDecoration: 'underline',
              fontSize: '12px',
              fontWeight: '700'
            }}
          >
            🏆 View Live Guest Card
          </a>
          <a
            href="/demobook"
            style={{
              background: '#ffffff',
              color: '#0f172a',
              padding: '4px 12px',
              borderRadius: '6px',
              textDecoration: 'none',
              fontSize: '11px',
              fontWeight: '700',
              transition: 'background 0.15s'
            }}
          >
            Go to Booking Demo &rarr;
          </a>
        </div>
      </div>

      {/* 2. LODGE NAVIGATION BAR */}
      <nav style={{
        background: 'rgba(11, 19, 41, 0.95)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
        position: 'sticky',
        top: '38px',
        zIndex: 900,
        padding: '14px 24px'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '20px'
        }}>
          {/* Logo / Brand */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '42px',
              height: '42px',
              borderRadius: '10px',
              background: 'linear-gradient(135deg, #1e3a8a 0%, #d4af37 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '20px',
              boxShadow: '0 4px 12px rgba(212, 175, 55, 0.3)',
              border: '1px solid rgba(255, 255, 255, 0.2)'
            }}>
              🎣
            </div>
            <div>
              <div style={{
                fontSize: '17px',
                fontWeight: '800',
                letterSpacing: '1px',
                color: '#ffffff',
                textTransform: 'uppercase'
              }}>
                Fisherman&apos;s Tale
              </div>
              <div style={{
                fontSize: '10.5px',
                fontWeight: '600',
                letterSpacing: '1.5px',
                color: '#d4af37',
                textTransform: 'uppercase'
              }}>
                Wilderness Lodge &amp; Expeditions
              </div>
            </div>
          </div>

          {/* Desktop Nav Links */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '24px',
            fontSize: '13.5px',
            fontWeight: '600',
            color: '#cbd5e1'
          }}>
            <a href="#trophycoin" style={{ color: '#fde68a', textDecoration: 'none', transition: 'color 0.15s' }}>
              ✨ TrophyCoin Experience
            </a>
            <a href="#charters" style={{ color: '#cbd5e1', textDecoration: 'none', transition: 'color 0.15s' }}>
              Charters &amp; Fleet
            </a>
            <a href="#accommodations" style={{ color: '#cbd5e1', textDecoration: 'none', transition: 'color 0.15s' }}>
              Luxury Suites
            </a>
            <a href="#reviews" style={{ color: '#cbd5e1', textDecoration: 'none', transition: 'color 0.15s' }}>
              Guest Stories
            </a>
            <a
              href="/demobook"
              style={{
                background: 'linear-gradient(135deg, #d4af37 0%, #b45309 100%)',
                color: '#070b14',
                padding: '10px 22px',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '700',
                fontSize: '13px',
                boxShadow: '0 4px 14px rgba(212, 175, 55, 0.35)',
                transition: 'all 0.2s',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              <span>Book Your Stay</span>
              <span>&rarr;</span>
            </a>
          </div>
        </div>
      </nav>

      {/* 3. HERO SECTION */}
      <section style={{
        position: 'relative',
        minHeight: '75vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '80px 20px',
        background: 'radial-gradient(circle at 50% 30%, rgba(30, 58, 138, 0.35) 0%, rgba(7, 11, 20, 0.95) 75%), url("https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=1600&auto=format&fit=crop&q=80") center/cover no-repeat',
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)'
      }}>
        <div style={{
          maxWidth: '900px',
          margin: '0 auto',
          textAlign: 'center',
          position: 'relative',
          zIndex: 2
        }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            background: 'rgba(212, 175, 55, 0.12)',
            border: '1px solid rgba(212, 175, 55, 0.35)',
            color: '#fef08a',
            padding: '6px 14px',
            borderRadius: '999px',
            fontSize: '12px',
            fontWeight: '700',
            letterSpacing: '0.5px',
            marginBottom: '20px'
          }}>
            <span>★</span>
            <span>Premier Wilderness Lodge &bull; Official TrophyCoin Certified Outfitter</span>
          </div>

          <h1 style={{
            fontSize: 'clamp(32px, 5.5vw, 56px)',
            fontWeight: '900',
            lineHeight: 1.15,
            letterSpacing: '-0.5px',
            margin: '0 0 20px 0',
            background: 'linear-gradient(180deg, #ffffff 40%, #cbd5e1 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}>
            Where Wilderness Legends Become Certified Keepsakes.
          </h1>

          <p style={{
            fontSize: 'clamp(15px, 2vw, 18px)',
            lineHeight: 1.6,
            color: '#94a3b8',
            maxWidth: '680px',
            margin: '0 auto 32px auto'
          }}>
            Experience world-record trophy angling on untamed waters, five-star riverside dining, and custom minted metallic <strong style={{ color: '#fde68a' }}>TrophyCoin&trade; brag cards</strong> that preserve your triumphs forever.
          </p>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: '14px'
          }}>
            <a
              href="/demobook"
              style={{
                background: 'linear-gradient(135deg, #d4af37 0%, #b45309 100%)',
                color: '#070b14',
                padding: '14px 28px',
                borderRadius: '10px',
                textDecoration: 'none',
                fontWeight: '800',
                fontSize: '15px',
                boxShadow: '0 8px 24px rgba(212, 175, 55, 0.4)',
                transition: 'all 0.2s',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              <span>Explore Charters &amp; Reserve</span>
              <span>&rarr;</span>
            </a>

            <a
              href="/c/0006ccf49cf46d98"
              target="_blank"
              rel="noreferrer"
              style={{
                background: 'rgba(255, 255, 255, 0.08)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                color: '#ffffff',
                padding: '14px 26px',
                borderRadius: '10px',
                textDecoration: 'none',
                fontWeight: '700',
                fontSize: '15px',
                backdropFilter: 'blur(8px)',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                transition: 'all 0.2s'
              }}
            >
              <span>📱 Test Live Trophy Card</span>
              <span style={{ fontSize: '12px', opacity: 0.8 }}>&#8599;</span>
            </a>
          </div>
        </div>
      </section>

      {/* 4. THE TROPHYCOIN EXPERIENCE SPOTLIGHT (THE SALES PITCH TO LODGES) */}
      <section id="trophycoin" style={{
        padding: '80px 24px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '48px' }}>
          <div style={{
            display: 'inline-block',
            color: '#d4af37',
            fontSize: '12px',
            fontWeight: '800',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            marginBottom: '10px'
          }}>
            The TrophyCoin&trade; Partner Advantage
          </div>
          <h2 style={{
            fontSize: 'clamp(26px, 4vw, 38px)',
            fontWeight: '800',
            color: '#ffffff',
            margin: '0 0 16px 0'
          }}>
            Every Guest Leaves With More Than A Story.
          </h2>
          <p style={{
            fontSize: '15px',
            color: '#94a3b8',
            maxWidth: '650px',
            margin: '0 auto',
            lineHeight: 1.6
          }}>
            How Fisherman&apos;s Tale Lodge turns memorable catches into lifetime physical memorabilia, viral WhatsApp bragging, and automated repeat bookings.
          </p>
        </div>

        {/* 4-Step Flywheel Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: '20px',
          marginBottom: '50px'
        }}>
          {/* Step 1 */}
          <div style={{
            background: 'rgba(255, 255, 255, 0.03)',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            borderRadius: '16px',
            padding: '24px',
            position: 'relative'
          }}>
            <div style={{
              width: '38px',
              height: '38px',
              borderRadius: '8px',
              background: 'rgba(56, 189, 248, 0.15)',
              color: '#38bdf8',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '16px',
              fontWeight: '800',
              marginBottom: '16px'
            }}>
              1
            </div>
            <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#ffffff', margin: '0 0 10px 0' }}>
              60-Second On-Water Certification
            </h3>
            <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: 1.6, margin: 0 }}>
              The moment your guest lands their trophy, the skipper logs species, weight, length, coordinates, and photo right from their smartphone.
            </p>
          </div>

          {/* Step 2 */}
          <div style={{
            background: 'rgba(255, 255, 255, 0.03)',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            borderRadius: '16px',
            padding: '24px',
            position: 'relative'
          }}>
            <div style={{
              width: '38px',
              height: '38px',
              borderRadius: '8px',
              background: 'rgba(245, 158, 11, 0.15)',
              color: '#f59e0b',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '16px',
              fontWeight: '800',
              marginBottom: '16px'
            }}>
              2
            </div>
            <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#ffffff', margin: '0 0 10px 0' }}>
              Engraved Metallic Keepsake
            </h3>
            <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: 1.6, margin: 0 }}>
              Presented at the evening dinner: a heavy, minted coin embedded with an NFC microchip, certified with the lodge emblem and guest achievement.
            </p>
          </div>

          {/* Step 3 */}
          <div style={{
            background: 'rgba(255, 255, 255, 0.03)',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            borderRadius: '16px',
            padding: '24px',
            position: 'relative'
          }}>
            <div style={{
              width: '38px',
              height: '38px',
              borderRadius: '8px',
              background: 'rgba(168, 85, 247, 0.15)',
              color: '#a855f7',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '16px',
              fontWeight: '800',
              marginBottom: '16px'
            }}>
              3
            </div>
            <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#ffffff', margin: '0 0 10px 0' }}>
              Instant Phone Tap &bull; 3D Card
            </h3>
            <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: 1.6, margin: 0 }}>
              No app download required. Tapping the coin to any iPhone or Android loads the 3D flippable brag card with verified catch stamps and lodge info.
            </p>
          </div>

          {/* Step 4 */}
          <div style={{
            background: 'rgba(255, 255, 255, 0.03)',
            border: '1px solid rgba(212, 175, 55, 0.25)',
            borderRadius: '16px',
            padding: '24px',
            position: 'relative'
          }}>
            <div style={{
              width: '38px',
              height: '38px',
              borderRadius: '8px',
              background: 'rgba(16, 185, 129, 0.15)',
              color: '#10b981',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '16px',
              fontWeight: '800',
              marginBottom: '16px'
            }}>
              4
            </div>
            <h3 style={{ fontSize: '16px', fontWeight: '700', color: '#fef08a', margin: '0 0 10px 0' }}>
              Direct Rebooking &amp; Referrals
            </h3>
            <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: 1.6, margin: 0 }}>
              When guests share to WhatsApp or social media, friends tap the card back and click &ldquo;Book With This Lodge&rdquo; directly into your calendar!
            </p>
          </div>
        </div>

        {/* Interactive Feature Demo Box */}
        <div style={{
          background: 'radial-gradient(ellipse at 50% 0%, rgba(30, 58, 138, 0.25) 0%, rgba(15, 23, 42, 0.6) 100%)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '20px',
          padding: '36px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '30px'
        }}>
          <div style={{ flex: '1 1 450px' }}>
            <span style={{
              background: 'rgba(212, 175, 55, 0.15)',
              color: '#fde68a',
              border: '1px solid rgba(212, 175, 55, 0.3)',
              padding: '3px 10px',
              borderRadius: '6px',
              fontSize: '11px',
              fontWeight: '700',
              textTransform: 'uppercase'
            }}>
              Live Demo Interaction
            </span>
            <h3 style={{ fontSize: '24px', fontWeight: '800', color: '#ffffff', margin: '14px 0 10px 0' }}>
              See what your guests &amp; their friends experience
            </h3>
            <p style={{ fontSize: '14px', color: '#94a3b8', lineHeight: 1.6, margin: '0 0 20px 0' }}>
              Every coin is tied to a unique URL (`fishermanstale.com/c/...`). The card back carries your lodge&apos;s website, booking link, and contact details, fully tracked with engagement analytics.
            </p>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              <a
                href="/c/0006ccf49cf46d98"
                target="_blank"
                rel="noreferrer"
                style={{
                  background: '#d4af37',
                  color: '#000',
                  padding: '11px 22px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontSize: '13px',
                  fontWeight: '800',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px'
                }}
              >
                <span>Launch Interactive 3D Card</span>
                <span>&#8599;</span>
              </a>
              <a
                href="/demobook"
                style={{
                  background: 'rgba(255, 255, 255, 0.08)',
                  border: '1px solid rgba(255, 255, 255, 0.15)',
                  color: '#fff',
                  padding: '11px 20px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontSize: '13px',
                  fontWeight: '700'
                }}
              >
                Test Lodge Booking Flow &rarr;
              </a>
            </div>
          </div>

          <div style={{
            flex: '0 1 300px',
            background: 'rgba(0, 0, 0, 0.4)',
            border: '1px solid rgba(212, 175, 55, 0.3)',
            borderRadius: '16px',
            padding: '20px',
            textAlign: 'center',
            boxShadow: '0 12px 30px rgba(0,0,0,0.5)'
          }}>
            <div style={{ fontSize: '32px', marginBottom: '8px' }}>🪙</div>
            <div style={{ fontSize: '14px', fontWeight: '800', color: '#fef08a' }}>
              Official Minted Coin #1
            </div>
            <div style={{ fontSize: '11px', color: '#94a3b8', margin: '4px 0 14px 0' }}>
              NFC Microchip &bull; Verified Digital Seal
            </div>
            <div style={{
              background: '#0f172a',
              borderRadius: '8px',
              padding: '10px',
              fontSize: '11px',
              color: '#38bdf8',
              fontFamily: 'monospace',
              marginBottom: '14px'
            }}>
              https://fishermanstale.com/c/0006ccf49cf46d98
            </div>
            <a
              href="/c/0006ccf49cf46d98"
              target="_blank"
              rel="noreferrer"
              style={{
                display: 'block',
                background: 'linear-gradient(135deg, #1e3a8a 0%, #0284c7 100%)',
                color: '#ffffff',
                padding: '9px 16px',
                borderRadius: '6px',
                textDecoration: 'none',
                fontSize: '12px',
                fontWeight: '700'
              }}
            >
              Simulate NFC Tap Now
            </a>
          </div>
        </div>
      </section>

      {/* 5. CHARTERS & EXPEDITIONS SECTION */}
      <section id="charters" style={{
        padding: '70px 24px',
        backgroundColor: '#0a0f1d',
        borderTop: '1px solid rgba(255, 255, 255, 0.05)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.05)'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '44px' }}>
            <div style={{
              color: '#38bdf8',
              fontSize: '12px',
              fontWeight: '800',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              marginBottom: '8px'
            }}>
              Guided Wilderness Charters
            </div>
            <h2 style={{ fontSize: '32px', fontWeight: '800', color: '#ffffff', margin: 0 }}>
              Master-Guided River &amp; Lake Expeditions
            </h2>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: '24px'
          }}>
            {/* Charter 1 */}
            <div style={{
              background: '#0f172a',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              borderRadius: '16px',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column'
            }}>
              <div style={{
                height: '180px',
                background: 'url("https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800&auto=format&fit=crop&q=80") center/cover no-repeat',
                position: 'relative'
              }}>
                <span style={{
                  position: 'absolute',
                  top: '12px',
                  right: '12px',
                  background: 'rgba(0, 0, 0, 0.75)',
                  color: '#fef08a',
                  padding: '4px 10px',
                  borderRadius: '6px',
                  fontSize: '11px',
                  fontWeight: '700'
                }}>
                  Most Popular
                </span>
              </div>
              <div style={{ padding: '22px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#ffffff', margin: '0 0 6px 0' }}>
                  Tiger Fish Jet Boat Rapids Charter
                </h3>
                <div style={{ fontSize: '12px', color: '#94a3b8', marginBottom: '12px' }}>
                  Full-Day &bull; Up to 4 Anglers &bull; Master Skipper
                </div>
                <p style={{ fontSize: '13px', color: '#cbd5e1', lineHeight: 1.5, margin: '0 0 16px 0', flex: 1 }}>
                  Target ferocious Hydrocynus vittatus across fast river cataracts. Includes live bait, heavy tackle, and custom on-water TrophyCoin certification.
                </p>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 'auto' }}>
                  <div>
                    <span style={{ fontSize: '20px', fontWeight: '800', color: '#ffffff' }}>$850</span>
                    <span style={{ fontSize: '12px', color: '#64748b' }}> / boat / day</span>
                  </div>
                  <a
                    href="/demobook"
                    style={{
                      background: 'rgba(255, 255, 255, 0.1)',
                      color: '#ffffff',
                      padding: '8px 16px',
                      borderRadius: '6px',
                      textDecoration: 'none',
                      fontSize: '12px',
                      fontWeight: '700'
                    }}
                  >
                    Select &rarr;
                  </a>
                </div>
              </div>
            </div>

            {/* Charter 2 */}
            <div style={{
              background: '#0f172a',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              borderRadius: '16px',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column'
            }}>
              <div style={{
                height: '180px',
                background: 'url("https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&auto=format&fit=crop&q=80") center/cover no-repeat'
              }} />
              <div style={{ padding: '22px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#ffffff', margin: '0 0 6px 0' }}>
                  Wilderness River Float &amp; Fly Drift
                </h3>
                <div style={{ fontSize: '12px', color: '#94a3b8', marginBottom: '12px' }}>
                  Full-Day &bull; 2 Anglers per Drift Boat
                </div>
                <p style={{ fontSize: '13px', color: '#cbd5e1', lineHeight: 1.5, margin: '0 0 16px 0', flex: 1 }}>
                  Quiet drift through canyon pools targeting trophy bream and trout. Handcrafted streamer flies provided, plus stream-side gourmet lunch.
                </p>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 'auto' }}>
                  <div>
                    <span style={{ fontSize: '20px', fontWeight: '800', color: '#ffffff' }}>$650</span>
                    <span style={{ fontSize: '12px', color: '#64748b' }}> / boat / day</span>
                  </div>
                  <a
                    href="/demobook"
                    style={{
                      background: 'rgba(255, 255, 255, 0.1)',
                      color: '#ffffff',
                      padding: '8px 16px',
                      borderRadius: '6px',
                      textDecoration: 'none',
                      fontSize: '12px',
                      fontWeight: '700'
                    }}
                  >
                    Select &rarr;
                  </a>
                </div>
              </div>
            </div>

            {/* Charter 3 */}
            <div style={{
              background: '#0f172a',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              borderRadius: '16px',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column'
            }}>
              <div style={{
                height: '180px',
                background: 'url("https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800&auto=format&fit=crop&q=80") center/cover no-repeat'
              }} />
              <div style={{ padding: '22px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#ffffff', margin: '0 0 6px 0' }}>
                  Heli-Angling Remote Gorge Expedition
                </h3>
                <div style={{ fontSize: '12px', color: '#94a3b8', marginBottom: '12px' }}>
                  VIP Charter &bull; Inaccessible Backcountry Waters
                </div>
                <p style={{ fontSize: '13px', color: '#cbd5e1', lineHeight: 1.5, margin: '0 0 16px 0', flex: 1 }}>
                  Helicopter drop directly into untouched river gorges with zero fishing pressure. Guaranteed IGFA record-class angling.
                </p>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 'auto' }}>
                  <div>
                    <span style={{ fontSize: '20px', fontWeight: '800', color: '#ffffff' }}>$2,400</span>
                    <span style={{ fontSize: '12px', color: '#64748b' }}> / flight charter</span>
                  </div>
                  <a
                    href="/demobook"
                    style={{
                      background: 'rgba(255, 255, 255, 0.1)',
                      color: '#ffffff',
                      padding: '8px 16px',
                      borderRadius: '6px',
                      textDecoration: 'none',
                      fontSize: '12px',
                      fontWeight: '700'
                    }}
                  >
                    Select &rarr;
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 6. ACCOMMODATIONS SECTION */}
      <section id="accommodations" style={{
        padding: '70px 24px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '44px' }}>
          <div style={{
            color: '#d4af37',
            fontSize: '12px',
            fontWeight: '800',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            marginBottom: '8px'
          }}>
            Rustic Luxury
          </div>
          <h2 style={{ fontSize: '32px', fontWeight: '800', color: '#ffffff', margin: 0 }}>
            Riverfront Suites &amp; Private Chalets
          </h2>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))',
          gap: '24px'
        }}>
          {/* Suite 1 */}
          <div style={{
            background: 'rgba(255, 255, 255, 0.02)',
            border: '1px solid rgba(255, 255, 255, 0.07)',
            borderRadius: '14px',
            padding: '24px'
          }}>
            <div style={{ fontSize: '20px', fontWeight: '800', color: '#ffffff', marginBottom: '4px' }}>
              The Riverbank Master Suite
            </div>
            <div style={{ fontSize: '13px', color: '#d4af37', marginBottom: '14px' }}>
              Panoramic River Balcony &bull; King Featherbed &bull; Soaking Tub
            </div>
            <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: 1.6, margin: '0 0 16px 0' }}>
              Unobstructed water views, wood-burning stone hearth, private fly-tying workspace, and evening turn-down service with local craft spirits.
            </p>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span style={{ fontSize: '16px', fontWeight: '700', color: '#fff' }}>From $495 / night</span>
              <a href="/demobook" style={{ color: '#fde68a', fontSize: '12px', fontWeight: '700', textDecoration: 'none' }}>
                Check Dates &rarr;
              </a>
            </div>
          </div>

          {/* Suite 2 */}
          <div style={{
            background: 'rgba(255, 255, 255, 0.02)',
            border: '1px solid rgba(255, 255, 255, 0.07)',
            borderRadius: '14px',
            padding: '24px'
          }}>
            <div style={{ fontSize: '20px', fontWeight: '800', color: '#ffffff', marginBottom: '4px' }}>
              Angler&apos;s Two-Bedroom Timber Cabin
            </div>
            <div style={{ fontSize: '13px', color: '#d4af37', marginBottom: '14px' }}>
              Accommodates 4 &bull; Cedar Hot Tub &bull; Gear Drying Room
            </div>
            <p style={{ fontSize: '13px', color: '#94a3b8', lineHeight: 1.6, margin: '0 0 16px 0' }}>
              Designed for fishing groups and families. Features dedicated rod racks, heated boot dryers, a screened porch, and a private fire pit.
            </p>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span style={{ fontSize: '16px', fontWeight: '700', color: '#fff' }}>From $750 / night</span>
              <a href="/demobook" style={{ color: '#fde68a', fontSize: '12px', fontWeight: '700', textDecoration: 'none' }}>
                Check Dates &rarr;
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* 7. GUEST STORIES / TESTIMONIALS */}
      <section id="reviews" style={{
        padding: '70px 24px',
        backgroundColor: '#0a0f1d',
        borderTop: '1px solid rgba(255, 255, 255, 0.05)'
      }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto', textAlign: 'center' }}>
          <div style={{
            color: '#10b981',
            fontSize: '12px',
            fontWeight: '800',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            marginBottom: '8px'
          }}>
            Real Angler Reviews
          </div>
          <h2 style={{ fontSize: '32px', fontWeight: '800', color: '#ffffff', margin: '0 0 36px 0' }}>
            What Our Guests Take Home
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '20px',
            textAlign: 'left'
          }}>
            <div style={{
              background: '#0f172a',
              border: '1px solid rgba(255, 255, 255, 0.07)',
              borderRadius: '12px',
              padding: '22px'
            }}>
              <div style={{ color: '#f59e0b', fontSize: '14px', marginBottom: '10px' }}>★★★★★</div>
              <p style={{ fontSize: '13px', color: '#cbd5e1', lineHeight: 1.6, margin: '0 0 14px 0' }}>
                &ldquo;The tiger fishing was phenomenal, but receiving our physical TrophyCoin at dinner was the highlight. Tapping my phone to show the 3D card back home blew away everyone at my fishing club!&rdquo;
              </p>
              <div style={{ fontSize: '12px', fontWeight: '700', color: '#ffffff' }}>
                Marcus Vance
              </div>
              <div style={{ fontSize: '11px', color: '#64748b' }}>
                Dallas, Texas &bull; Landed 18.2 LBS Tiger Fish
              </div>
            </div>

            <div style={{
              background: '#0f172a',
              border: '1px solid rgba(255, 255, 255, 0.07)',
              borderRadius: '12px',
              padding: '22px'
            }}>
              <div style={{ color: '#f59e0b', fontSize: '14px', marginBottom: '10px' }}>★★★★★</div>
              <p style={{ fontSize: '13px', color: '#cbd5e1', lineHeight: 1.6, margin: '0 0 14px 0' }}>
                &ldquo;World-class skippers, gourmet river-to-table dinners, and the card verification is next-level tech. Two of my coworkers already booked after I sent them my card on WhatsApp.&rdquo;
              </p>
              <div style={{ fontSize: '12px', fontWeight: '700', color: '#ffffff' }}>
                David &amp; Sarah Jenkins
              </div>
              <div style={{ fontSize: '11px', color: '#64748b' }}>
                Calgary, AB &bull; Annual Wilderness Package
              </div>
            </div>

            <div style={{
              background: '#0f172a',
              border: '1px solid rgba(255, 255, 255, 0.07)',
              borderRadius: '12px',
              padding: '22px'
            }}>
              <div style={{ color: '#f59e0b', fontSize: '14px', marginBottom: '10px' }}>★★★★★</div>
              <p style={{ fontSize: '13px', color: '#cbd5e1', lineHeight: 1.6, margin: '0 0 14px 0' }}>
                &ldquo;As a charter captain myself, seeing a lodge certify catches with cryptographic seals and NFC coins is genius. It completely eliminates fish stories and turns guests into promoters.&rdquo;
              </p>
              <div style={{ fontSize: '12px', fontWeight: '700', color: '#ffffff' }}>
                Capt. Brent Holloway
              </div>
              <div style={{ fontSize: '11px', color: '#64748b' }}>
                Key West, Florida
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 8. SALES FAQ / OPERATOR HIGHLIGHTS */}
      <section style={{
        padding: '70px 24px',
        maxWidth: '850px',
        margin: '0 auto'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '36px' }}>
          <h2 style={{ fontSize: '28px', fontWeight: '800', color: '#ffffff', margin: '0 0 8px 0' }}>
            Frequently Asked Questions
          </h2>
          <p style={{ fontSize: '14px', color: '#94a3b8' }}>
            Everything you need to know about our lodge and the TrophyCoin experience.
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {[
            {
              q: "How does the physical TrophyCoin keepsake work for our guests?",
              a: "When a guest catches a trophy fish on a guided charter, the guide logs the details on mobile. A customized, heavy metallic coin is awarded at dinner. Tapping any smartphone to the coin instantly opens the verified 3D digital brag card with your lodge's branding and booking links."
            },
            {
              q: "Can our lodge customize the design of the brag cards and coins?",
              a: "Yes! Through the TrophyCoin Design Studio, lodges can customize card dimensions, logos, background patterns, and dataset variables (angler name, catch coordinates, guide name, species, etc.)."
            },
            {
              q: "How do card shares drive direct bookings back to the lodge?",
              a: "Every card shared via WhatsApp, X, or Facebook includes links back to your lodge website and booking page. Full analytics track how many shares and referral views each catch generates."
            },
            {
              q: "What equipment is included in the charter packages?",
              a: "All guided packages include premium rods, reels, braided line, terminal tackle, custom lures, and USCG/safety equipment. Guests are welcome to bring personal fly tackle."
            }
          ].map((item, idx) => (
            <div
              key={idx}
              style={{
                background: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid rgba(255, 255, 255, 0.08)',
                borderRadius: '10px',
                overflow: 'hidden'
              }}
            >
              <button
                type="button"
                onClick={() => toggleFaq(idx)}
                style={{
                  width: '100%',
                  background: 'none',
                  border: 'none',
                  color: '#ffffff',
                  padding: '16px 20px',
                  fontSize: '14px',
                  fontWeight: '700',
                  textAlign: 'left',
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <span>{item.q}</span>
                <span style={{ color: '#d4af37', fontSize: '16px' }}>{activeFaq === idx ? '−' : '+'}</span>
              </button>
              {activeFaq === idx && (
                <div style={{
                  padding: '0 20px 16px 20px',
                  fontSize: '13px',
                  color: '#94a3b8',
                  lineHeight: 1.6
                }}>
                  {item.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* 9. BOTTOM CALL TO ACTION */}
      <section style={{
        padding: '60px 24px',
        background: 'linear-gradient(180deg, rgba(30, 58, 138, 0.25) 0%, rgba(7, 11, 20, 0.95) 100%)',
        textAlign: 'center',
        borderTop: '1px solid rgba(255, 255, 255, 0.08)'
      }}>
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '30px', fontWeight: '800', color: '#ffffff', margin: '0 0 14px 0' }}>
            Ready to Plan Your Wilderness Stay?
          </h2>
          <p style={{ fontSize: '14px', color: '#94a3b8', margin: '0 0 28px 0', lineHeight: 1.5 }}>
            Dates fill 6–9 months in advance during prime river runs. Reserve your dates online or speak with our lodge concierge.
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '14px', flexWrap: 'wrap' }}>
            <a
              href="/demobook"
              style={{
                background: 'linear-gradient(135deg, #d4af37 0%, #b45309 100%)',
                color: '#070b14',
                padding: '14px 32px',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '800',
                fontSize: '14px',
                boxShadow: '0 6px 20px rgba(212, 175, 55, 0.35)'
              }}
            >
              Launch Booking Demo &rarr;
            </a>
            <a
              href="/c/0006ccf49cf46d98"
              target="_blank"
              rel="noreferrer"
              style={{
                background: 'rgba(255, 255, 255, 0.08)',
                border: '1px solid rgba(255, 255, 255, 0.15)',
                color: '#fff',
                padding: '14px 24px',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '700',
                fontSize: '14px'
              }}
            >
              View Sample Trophy Card &#8599;
            </a>
          </div>
        </div>
      </section>

      {/* 10. LODGE FOOTER */}
      <footer style={{
        background: '#04070d',
        borderTop: '1px solid rgba(255, 255, 255, 0.05)',
        padding: '40px 24px 24px 24px',
        fontSize: '12px',
        color: '#64748b'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '20px',
          paddingBottom: '24px',
          borderBottom: '1px solid rgba(255, 255, 255, 0.05)'
        }}>
          <div>
            <div style={{ color: '#ffffff', fontWeight: '800', fontSize: '14px', marginBottom: '4px' }}>
              FISHERMAN&apos;S TALE LODGE &amp; EXPEDITIONS
            </div>
            <div>Mile 42 River Road &bull; Zambezi River Catchment Basin</div>
            <div style={{ marginTop: '4px' }}>concierge@fishermanstale.com &bull; +1 (800) 555-FISH</div>
          </div>
          <div style={{ display: 'flex', gap: '20px' }}>
            <a href="/demosite" style={{ color: '#94a3b8', textDecoration: 'none' }}>Lodge Home</a>
            <a href="/demobook" style={{ color: '#94a3b8', textDecoration: 'none' }}>Booking Demo</a>
            <a href="/c/0006ccf49cf46d98" style={{ color: '#fde68a', textDecoration: 'none' }}>Sample Brag Card</a>
          </div>
        </div>
        <div style={{
          maxWidth: '1200px',
          margin: '18px auto 0 auto',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '12px'
        }}>
          <div>
            &copy; 2026 Fisherman&apos;s Tale Lodge. All rights reserved. Demo prototype powered by TrophyCoin&trade;.
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#d4af37' }}>
            <span>🏆 Official TrophyCoin&trade; Certified Outfitter</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
